import script from "./MultiCameraFootage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiCameraFootage.vue?vue&type=script&lang=ts&setup=true"

import "./MultiCameraFootage.vue?vue&type=style&index=0&id=51b6d874&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51b6d874"]])

export default __exports__